module.exports = __webpack_public_path__ + "img/newJD-right-tick.d58403a0.svg";